import { useEffect, useState } from "react";

// Lädt einen CMS-Inhalt (/content/<name>.json) zur Laufzeit.
// Gibt null zurück, solange geladen wird. Ist kein CMS-Server erreichbar
// (z.B. rein statisches Hosting), wird der mitgebaute Stand verwendet.
export default function useContent(name, fallback) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`/content/${name}.json`, { cache: "no-cache" })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((json) => !cancelled && setData(json))
      .catch(() => !cancelled && setData(fallback));
    return () => {
      cancelled = true;
    };
  }, [name, fallback]);

  return data;
}
